import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { gray100, primaryButtonBackgroundColor } from '../../../constants/colors';
import { adminCompletePageStyles as layoutStyles } from '../../../constants/adminCompletePageStyles';
import SideBar from '../menu/SideBar';
import MetaTitle from '../../utils/MetaTitle';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
  },
  text: {
    fontSize: '16px',
    color: gray100,
    textAlign: 'center',
  },
};

type AdminNoPermissionProps = {
  companyId?: string;
};

const AdminNoPermission: React.FC<AdminNoPermissionProps> = ({ companyId }): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.text}>この画面を表示する権限がありません。</Typography>
      <Button
        onClick={(): void => navigate(companyId ? `/admin/company/${companyId}` : '/admin/company')}
        sx={[primaryButtonBackgroundColor, { width: '200px', height: '44px' }]}
        variant="contained"
      >
        企業詳細へ戻る
      </Button>
    </Box>
  );
};

export default AdminNoPermission;

type AdminNoPermissionPageProps = {
  companyId?: string;
  customTitle?: string;
};

export const AdminNoPermissionPage: React.FC<AdminNoPermissionPageProps> = ({
  companyId,
  customTitle,
}): JSX.Element => (
  <>
    <MetaTitle customTitle={customTitle} />
    <Box sx={layoutStyles.page}>
      <Box sx={layoutStyles.sidebar}>
        <SideBar />
      </Box>
      <Box sx={layoutStyles.container}>
        <AdminNoPermission companyId={companyId} />
      </Box>
    </Box>
  </>
);
